export default __webpack_public_path__ + "static/media/solution-left.e8132aa3.svg";